import type { AudienceFilterItem } from '@/types/audienceFilters.types';

export interface AudienceQueryParams {
  audience_id?: string;
}

/**
 * Mapea la audiencia elegida a los query params del BFF.
 *
 * Omitir `audience_id` NO significa "todas": el BFF lo interpreta como "la audiencia primaria
 * del tenant", que para un tenant sin audiencias es su única fila. Por eso omitirlo reproduce
 * exactamente el comportamiento previo a las audiencias.
 */
export function resolveAudienceQueryParams(audienceId?: string): AudienceQueryParams {
  if (audienceId === undefined || audienceId === '') {
    return {};
  }
  return { audience_id: String(audienceId) };
}

/**
 * Audiencia que debe quedar seleccionada, dado el catálogo y lo que hubiera guardado.
 *
 * El catálogo llega ordenado por `sort_order`, así que la primera es la primaria del tenant.
 * Reglas: si no hay catálogo no hay selección; si la guardada ya no existe (la desactivaron o
 * bajó de cobertura) se cae a la primera en vez de dejar un filtro colgado que no devuelve nada.
 */
export function resolveSelectedAudienceId(
  audiences: AudienceFilterItem[] | undefined,
  storedId: string | undefined
): string | undefined {
  if (!audiences?.length) return undefined;
  if (storedId && audiences.some(a => a.id === storedId)) return storedId;
  return audiences[0].id;
}
